// @flow
import React from 'react';

const AccountAddressesPageComponent = () => {
  return <div className="account-addresses-page-component" />;
};

export default AccountAddressesPageComponent;
